import toHex from 'colornames'

export function colorToHex(color: string) {
  return toHex(color) || color
}
